import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 그룹 목록 조회
export const getGroupsList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .get("/groups", { params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹 등록하기
export const createGroups = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/groups", body)
      .then((res) => {
        toast.success("그룹이 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹 개편
export const createGroupsOrganize = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/groups/organize", body)
      .then((res) => {
        toast.success("그룹 개편이 완료되었습니다.", "", {
          timeOut: 100,
          extendedTimeOut: 100,
          closeButton: false,
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹 상세 조회
export const getGroups = (groupIdx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/groups/${groupIdx}`, { params })
      .then((res) => {
        // toast.success("그룹 상세 조회가 되었습니다.", "", {
        //   timeOut: 100,
        //   extendedTimeOut: 100,
        //   closeButton: false,
        // });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹 수정
export const modifyGroups = (groupIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/groups/${groupIdx}`, body)
      .then((res) => {
        toast.success("그룹이 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹 삭제
export const deleteGroups = (groupIdx, data = {}) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/groups/${groupIdx}`, { data })
      .then((res) => {
        toast.success("그룹이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹에 직원 등록
export const createEmployeeInGroups = (groupIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/groups/${groupIdx}/employees`, body)
      .then((res) => {
        toast.success("그룹에 직원이 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹에 직원 개편
export const createEmployeeInGroupsOrganize = (groupIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/groups/${groupIdx}/employees/organize`, body)
      .then((res) => {
        toast.success("그룹 직원 개편이 완료되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹에 직원 수정
export const modifyEmployeeInGroups = (groupIdx, employeeIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/groups/${groupIdx}/employees/${employeeIdx}`, body)
      .then((res) => {
        toast.success("그룹 직원이 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 그룹에 직원 삭제
export const deleteEmployeeInGroups = (groupIdx, employeeIdx, data = {}) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/groups/${groupIdx}/employees/${employeeIdx}`, { data })
      .then((res) => {
        toast.success("그룹의 직원이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
